import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import color from "../../../Constants/colors";

interface Props {
  terms: string[];
  emptyText: string;
}

const VoicesTermChips: React.FC<Props> = ({ terms, emptyText }) => {
  if (!terms.length) {
    return (
      <Typography variant="body2" sx={{ color: color.gray500 }}>
        {emptyText}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {terms.map((term) => (
        <Chip
          key={term}
          label={term}
          size="small"
          sx={{
            backgroundColor: color.orange50,
            border: `1px solid ${color.orange200}`,
            color: color.gray900,
          }}
        />
      ))}
    </Box>
  );
};

export default VoicesTermChips;
